import { TVNZ_NETWORK } from '../redux/constants';
import { TVNZ_STATION } from '../services/calculate';

const mapStationToNetwork = (station: TVNZ_STATION): TVNZ_NETWORK => {
  if (station === TVNZ_STATION.ONE) return TVNZ_NETWORK.ONE;
  if (station === TVNZ_STATION.TWO) return TVNZ_NETWORK.TWO;
  return TVNZ_NETWORK.DUKE;
};

export default mapStationToNetwork;
